import React from 'react'
import PropTypes from 'prop-types'
import { compose, lifecycle, withState } from 'recompose'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import reduxForm from 'components/common/hoc/withFormErrorFocus'
import { getIsModal } from 'selectors/modal'
import form from './form'
import validate from './validate'
import withSubmit from './withSubmit'
import { FORM_NAME } from './constants'
import ForgotPasswordWrapper from './ForgotPasswordWrapper'
import ForgotPasswordLockedWrapper from './ForgotPasswordLockedWrapper'

const ForgotPassword = ({
  isAccountLocked,
  onClose,
  title,
  forgotPasswordInstructions,
  description,
  email,
  submitting,
  submitSucceeded,
  handleHide,
  handleSubmit
}) =>
  isAccountLocked ?
    <ForgotPasswordLockedWrapper
      form={ form }
      email={ email }
      title={ title }
      description={ description }
      submitting={ submitting }
      submitSucceeded={ submitSucceeded }
      handleSubmit={ handleSubmit }
      handleClose={ onClose } /> :
    <ForgotPasswordWrapper
      form={ form }
      instructions={ forgotPasswordInstructions }
      description={ description }
      submitting={ submitting }
      submitSucceeded={ submitSucceeded }
      handleSubmit={ handleSubmit }
      handleHide={ handleHide } />

ForgotPassword.propTypes = {
  description: PropTypes.string,
  email: PropTypes.string,
  forgotPasswordInstructions: PropTypes.string,
  handleHide: PropTypes.func,
  handleSubmit: PropTypes.func,
  isAccountLocked: PropTypes.bool,
  onClose: PropTypes.func,
  submitSucceeded: PropTypes.bool,
  submitting: PropTypes.bool,
  title: PropTypes.string
}

const selector = formValueSelector(FORM_NAME)

const withResetForgotPasswordTitle = lifecycle({
  componentDidMount() {
    const { setForgotPasswordTitle } = this.props
    setForgotPasswordTitle && setForgotPasswordTitle()
  }
})

const mapStateToProps = state => ({
  email: selector(state, form.email.name) || ''
})

const withDescriptionState = withState('description', 'setDescription', '')

const EnhancedForgotPassword = compose(
  withResetForgotPasswordTitle,
  connect(state => ({ isModal: getIsModal(state) })),
  withDescriptionState,
  withSubmit,
  reduxForm({ form: FORM_NAME, validate, isModal: true }),
  connect(mapStateToProps)
)(ForgotPassword)

EnhancedForgotPassword.type = 'ForgotPassword'

export default EnhancedForgotPassword
